import { render, staticRenderFns } from "./GiftPackAnimation.vue?vue&type=template&id=058b2d3b&scoped=true&"
import script from "./GiftPackAnimation.vue?vue&type=script&lang=js&"
export * from "./GiftPackAnimation.vue?vue&type=script&lang=js&"
import style0 from "./GiftPackAnimation.vue?vue&type=style&index=0&id=058b2d3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b2d3b",
  null
  
)

export default component.exports